import React, { useEffect, useRef, useState } from "react";
import Header from '../adminComponents/header/Header'
import {
    Box,
    Typography,
    Button,
    Grid,
    Card,
} from "@mui/material";
import { CiPlay1 } from "react-icons/ci";
import { useNavigate } from "react-router-dom";
import { FiCheckCircle } from "react-icons/fi";
import { getAboutUs } from "../services/AboutUs";
import { useMediaQueries } from "../usecontext/UseProvider";

const AdminAboutUs = () => {
    const videoRef = useRef(null); // Reference for the video element
    const [isPlaying, setIsPlaying] = useState(false); // State to track play/pause
    const [aboutUsData, setAboutUsData] = useState([])
    const navigate = useNavigate();
    const { setLoading } = useMediaQueries();

    const getAboutUsData = async () => {
        try {
            setLoading(true);
            const response = await getAboutUs();
            setAboutUsData(response.aboutUs);
            setLoading(false);
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        getAboutUsData();
    }, []);

    const handlePlayPause = () => {
        if (videoRef.current) {
            if (isPlaying) {
                videoRef.current.pause();
            } else {
                videoRef.current.play();
            }
            setIsPlaying(!isPlaying); // Toggle the state
        }
    };

    const handleVideoEnd = () => {
        setIsPlaying(false); // Reset play button when video ends
    };
    return (
        <>
            <Header title="About US" />
            <Box sx={{ pt: 3 }}>
                <Box textAlign={'end'} mb={2}>
                    <Button
                        onClick={() => navigate('/admin/aboutus/edit')}
                        variant="contained"
                        sx={{ bgcolor: "#01A0E2", color: "white", borderRadius: '30px' }}>
                        Change about us details
                    </Button>
                </Box>
                <Grid container spacing={6} alignItems="center">
                    {/* Left Section - Image */}
                    <Grid item xs={12} md={6} data-offset="200" textAlign={"center"}>
                        <Box
                            component="img"
                            src={aboutUsData?.image?.url}
                            alt="Swing"
                            className="w-100"
                        />
                        <Box
                            sx={{
                                display: "flex",
                                justifyContent: "space-between",
                                gap: 2,

                                pt: 3,
                                px: 1,
                            }}
                        >
                            <Box sx={{ textAlign: "left" }}>
                                <Typography
                                    variant={"h4"}
                                    sx={{
                                        fontWeight: "bold",
                                        transition: "transform 0.3s ease, color 0.3s ease",
                                        "&:hover": {
                                            transform: "scale(1.1)",
                                            color: "#01A0E2",
                                        },
                                        color: '#000'
                                    }}
                                >
                                    {aboutUsData?.yearsOfExperience?.slice(0, -1)}
                                    <span style={{ color: "#01A0E2" }}>{aboutUsData?.yearsOfExperience?.slice(-1)}</span>
                                </Typography>
                                <Typography variant={"body2"} sx={{ color: '#000' }}>Years of Experience</Typography>
                            </Box>
                            <Box sx={{ textAlign: "left" }}>
                                <Typography
                                    variant={"h4"}
                                    sx={{
                                        fontWeight: "bold",
                                        transition: "transform 0.3s ease, color 0.3s ease",
                                        "&:hover": {
                                            transform: "scale(1.1)",
                                            color: "#01A0E2",
                                        }, color: '#000'
                                    }}
                                >
                                    {aboutUsData?.satisfiedClients?.slice(0, -1)}
                                    <span style={{ color: "#01A0E2" }}>{aboutUsData?.satisfiedClients?.slice(-1)}</span>
                                </Typography>
                                <Typography variant={"body2"} sx={{ color: '#000' }}>Satisfied Customers</Typography>
                            </Box>
                            <Box sx={{ textAlign: "left" }}>
                                <Typography
                                    variant={"h4"}
                                    sx={{
                                        fontWeight: "bold",
                                        transition: "transform 0.3s ease, color 0.3s ease",
                                        "&:hover": {
                                            transform: "scale(1.1)",
                                            color: "#01A0E2",
                                        }, color: '#000'
                                    }}
                                >
                                    {aboutUsData?.zulaItems?.slice(0, -1)}
                                    <span style={{ color: "#01A0E2" }}>{aboutUsData?.zulaItems?.slice(-1)}</span>
                                </Typography>
                                <Typography variant={"body2"} sx={{ color: '#000' }}>Zula Items</Typography>
                            </Box>
                        </Box>
                    </Grid>

                    {/* Right Section - Content */}
                    <Grid item xs={12} md={6}>
                        <Typography
                            variant={"h4"}
                            sx={{ fontWeight: "bold", marginBottom: 3, color: '#000' }}
                        >
                            {aboutUsData.title}
                        </Typography>
                        <Typography
                            variant={"body2"}
                            sx={{
                                marginBottom: "1rem",
                                fontSize: "20px",
                                color: '#000'
                            }}
                        >
                            {aboutUsData?.description}
                        </Typography>
                        <Box>
                            {aboutUsData?.tags?.map((feature, index) => (
                                <Box
                                    key={index}
                                    display="flex"
                                    alignItems="center"
                                    gap={1}
                                    sx={{ marginBottom: 1.5 }}
                                >
                                    <FiCheckCircle style={{ color: "#01A0E2" }} />
                                    <Typography variant="body1" sx={{ color: '#000' }}>{feature}</Typography>
                                </Box>
                            ))}
                        </Box>
                        <Box
                            sx={{
                                mt: 3,
                                position: "relative",
                                display: "inline-block",
                                borderRadius: "8px",
                            }}
                        >
                            <Card
                                sx={{
                                    borderRadius: "0",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    flexDirection: "column",
                                    position: "relative",
                                    boxShadow: "none",
                                }}
                            >
                                <Box
                                    component="video"
                                    ref={videoRef} // Single video reference
                                    src={aboutUsData?.video?.url}
                                    loop={false}
                                    muted
                                    sx={{
                                        height: "300px",
                                        maxWidth: "100%",
                                        objectFit: "cover",
                                    }}
                                    onClick={handlePlayPause}
                                    onEnded={handleVideoEnd}
                                />
                                {!isPlaying && (
                                    <Box
                                        onClick={handlePlayPause}
                                        sx={{
                                            position: "absolute",
                                            top: "50%",
                                            left: "50%",
                                            transform: "translate(-50%, -50%)",
                                            backgroundColor: "transparent",
                                            border: '1px solid white',
                                            borderRadius: "50%",
                                            padding: "0.5rem",
                                            cursor: "pointer",
                                        }}
                                    >
                                        <Typography variant="h5" sx={{ backgroundColor: '#fff', display: 'flex', justifyContent: 'center', alignItems: 'center', p: 1, borderRadius: '50%' }}>
                                            <CiPlay1 style={{ color: '#01A0E2' }} />
                                        </Typography>
                                    </Box>
                                )}
                            </Card>
                        </Box>
                    </Grid>
                </Grid>
            </Box>
        </>
    )
}

export default AdminAboutUs
